module.exports = __webpack_public_path__ + "media/images/icons/audible-podcast-7175983ff92f53a244006c4f1cd98e7e.svg";